<template>
    <div>
        <Header />
        <b-container class="space-above">
            <b-row class="space-above-form space-below-header">
                <b-col>
                    <h2 class="primary-text-color">Dependencies are now easy</h2>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                </b-col>
                <b-col cols="4" class="space-above-steps">
                    <b-row>
                        <b-col class="space-above-form">
                            <CustomSearch :items="items_application" :placeholder="placeholder_application"
                                @update="set_application"></CustomSearch>
                        </b-col>
                    </b-row>
                    <b-row class="space-above-form">
                        <b-col></b-col>
                        <b-col>
                            <b-button class="homepage-search-button" v-on:click="search_application" type="submit">
                                Search
                            </b-button>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                </b-col>
                <b-col cols="4" class="space-above-steps">
                    <b-row>
                        <b-col class="space-above-form">
                            <CustomSearch :items="items_docker" :placeholder="placeholder_docker" @update="set_docker">
                            </CustomSearch>
                        </b-col>
                    </b-row>
                    <b-row class="space-above-form">
                        <b-col></b-col>
                        <b-col>
                            <b-button class="homepage-search-button" v-on:click="search_docker" type="submit">Search
                            </b-button>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                </b-col>
                <b-col cols="2">
                </b-col>
            </b-row>
        </b-container>
        <b-row class="space-above-comm background-join-community">
            <b-col></b-col>
            <b-col class="join-community-top">
                <h2>Join our community</h2>
            </b-col>
            <b-col></b-col>
        </b-row>
        <b-row class="white-font join-community">
            <b-col>
                <h3>Consume</h3>Every content that are provided as a part of this open source service is free to use to
                everybody. We encourage people to email us about any concern, questions or suggestion to our website
            </b-col>
            <b-col>
                <h3>Contribute</h3>We survive from the contributions and constant upgrading of all the script we have
                from our developer community.
            </b-col>
            <b-col>
                <h3>Monitor</h3>To maintain the quality of the content we provide through this website, we encourage
                people to report any subpar content
            </b-col>
        </b-row>
    </div>
</template>


<script>
    import CustomSearch from './CustomSearch.vue';
    import Header from './Header.vue';
    export default {
        name: 'Home',
        components: {
            Header,
            CustomSearch
        },
        data() {
            return {
                item_application: {},
                items_application: [
                    { name: 'python' },
                    { name: 'postgres' },
                    { name: 'mongodb' },
                    { name: 'postgres' },
                    { name: 'jq' }
                ],
                placeholder_application: "Search by Applications Name",
                item_docker: {},
                items_docker: [
                    { name: 'python' },
                    { name: 'postgres' },
                    { name: 'mongodb' },
                    { name: 'postgres' },
                    { name: 'docker:stable' }
                ],
                placeholder_docker: "Search by Docker Image"
            }
        },
        methods: {
            search_application() {
                if (Object.keys(this.item_application).length) {
                    this.$router.push({ name: 'Script', params: { script: this.item_application.name }, query: { 'type': 'Application' } });
                } else {
                    return;
                }
            },
            search_docker() {
                if (Object.keys(this.item_docker).length) {
                    this.$router.push({ name: 'Script', params: { script: this.item_docker.name }, query: { 'type': 'Docker' } });
                } else {
                    return;
                }

            },
            set_application(item) {
                this.item_application = item;
            },
            set_docker(item) {
                this.item_docker = item;
            }
        },
        mounted() {
            this.filtered_items = this.items;
        }
    }
</script>



<style scoped>
    .navbar-spacing {
        margin: 0px 0px 0px 10px;
    }

    .primary-text-color {
        color: #17a2b8;
    }

    .white-font {
        color: white !important;
    }

    .space-above {
        margin-top: 60px;
    }

    .space-below-header {
        margin-bottom: 15px;
    }

    .space-above-form {
        margin-top: 10px;
    }

    .space-above-comm {
        margin-top: 150px;
    }

    .space-above-steps {
        margin-top: 80px;
    }

    .home-page-search {
        height: 40px
    }

    .homepage-search-button {
        width: 200px
    }

    .join-community {
        background-color: #17a2b8;
        min-height: 150px;
        padding-top: 20px;
    }

    .background-join-community {
        background-color: #17a2b8
    }

    .join-community-top {
        margin-top: 10px
    }
</style>